import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { CoreService, DialogResult, DialogService, SaveFormEvent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, EMPTY_GUID, OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS, POP_UP_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';

@Component({
  selector: 'app-person-detail',
  templateUrl: './person-detail.component.html',
  styleUrl: './person-detail.component.scss'
})
export class PersonDetailComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {
  fieldTypeReplacements = OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.personDetail;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  userHasConcessionsTeamRole: boolean;
  userHasVptasTeamRole: boolean;
  userHasCoplStaffRole: boolean;
  showGenerateLinkingCode: boolean;
  showBankDetailsButton: boolean;
  showCreatePlacementButton: boolean;
  showEditContactDetailsButton: boolean;
  isPersonCarer: boolean;
  isPersonClient: boolean;
  isPersonOracleVendor: boolean;
  isCrisOrCrisspRecordPresent: boolean;

  private exitRoutePrefix: string = '';
  private applicationId: string = '';

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        if (id) {
          this.id = id;
          this.formServiceEndpoint = API_ENDPOINT_KEYS.getPersonConfigAndResponse;

          if (this.router.url.includes(ROUTE_CONSTANTS.person.updateCreateCarerApplicationPrefix)) {
            const applicationId = paramMap.get('applicationId');

            if (applicationId) {
              this.applicationId = applicationId;
              this.exitRoutePrefix = ROUTE_CONSTANTS.person.updateCreateCarerApplicationPrefix;
            }
          }
          else if (this.router.url.includes(ROUTE_CONSTANTS.person.updateCreatePlacementApplicationPrefix)) {
            const applicationId = paramMap.get('applicationId');

            if (applicationId) {
              this.applicationId = applicationId;
              this.exitRoutePrefix = ROUTE_CONSTANTS.person.updateCreatePlacementApplicationPrefix;
            }
          }
          else {
            let index = this.router.url.indexOf(`/${ROUTE_CONSTANTS.person.prefixDetail}/`);
            let routePrefix = this.router.url.substring(0, index);
            if (routePrefix !== '') {
              this.exitRoutePrefix = routePrefix;
            }
          }
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions = {
    };

    this.coreService.applicationFunctions = {
      isCustomerPortalApplication: () => false,
      home: () => this.home(),
      newConcessionsApplication: () => this.newConcessionsApplication(),
      showNewConcessionsApplicationBtn: () => this.showNewConcessionsApplicationBtn(),
      showCreateVptasBtns: () => this.showCreateVptasBtns(),
      generateOneTimeCode: () => this.generateOneTimeCode(),
      createNominatedPatient: () => this.createNominatedPatient(),
      createVptasApplication: () => this.createVptasApplication(),
      viewInvoices: () => this.viewInvoices(),
      bankDetails: () => this.bankDetails(),
      showGenerateOneTimeCodeBtn: () => this.showGenerateOneTimeCodeBtn(),
      showBankDetailsBtn: () => this.showBankDetailsButton,
      showEditContactDetailsBtn: () => this.showEditContactDetailsButton,
      showCreatePlacementBtn: () => this.showCreatePlacementButton,
      createPlacement: () => this.createPlacement(),
      editContactDetails: () => this.editContactDetails(),
    };
  }
  viewInvoices() {
    const navExtras = this.getNavigationExtras();
    const routeParts = ROUTE_CONSTANTS.vptasApplication.details.invoiceListByContact
      .replace(':contactId', this.id)
      .split('/')
      .filter(part => part);
    this.navigate(['/', ...routeParts], false, navExtras);
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {
    if (this.baseForm && this.baseForm.model) {
      this.userHasConcessionsTeamRole = event.userHasConcessionsTeamRole;
      this.userHasVptasTeamRole = event.userHasVptasTeamRole;
      this.userHasCoplStaffRole = event.userHasCoplStaffRole;
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
      this.showGenerateLinkingCode = event.showGenerateLinkingCode;
      this.showBankDetailsButton = event.showBankDetailsButton;
      this.showCreatePlacementButton = event.showCreatePlacementButton;
      this.showEditContactDetailsButton = event.showEditContactDetailsButton;
      this.isPersonCarer = event.isPersonCarer;
      this.isPersonClient = event.isPersonClient;
      this.isPersonOracleVendor = event.isPersonOracleVendor;
      this.isCrisOrCrisspRecordPresent = event.isCrisRecordsPresent;
    }
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  exit() {
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {
  }

  cancel(event: any) {
    this.navigateBackToHome();
  }

  actionButton_linkedApplicationsGrid_datagrid_colLink_applicationNumber_Clicked(event: any): void {
    const navExtras = this.getNavigationExtras();
    switch (event.event.data.applicationTypeId) {
      case REFERENCE_DATA_IDS.applicationType.createCarer:
      case REFERENCE_DATA_IDS.applicationType.updateCarer:
        this.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.prefix, ROUTE_CONSTANTS.applicationDetailCreateUpdateCarer.prefix, event.event.data.id], false, navExtras);
        break;
      case REFERENCE_DATA_IDS.applicationType.createPlacement:
      case REFERENCE_DATA_IDS.applicationType.updatePlacement:
        this.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.prefix, ROUTE_CONSTANTS.applicationDetailCreateUpdatePlacement.prefix, event.event.data.id], false, navExtras);
        break;
      case REFERENCE_DATA_IDS.applicationType.edapowGoldCardMunicipalRates:
      case REFERENCE_DATA_IDS.applicationType.nonMainsEnergy:
      case REFERENCE_DATA_IDS.applicationType.nonMainsLifeSupport:
      case REFERENCE_DATA_IDS.applicationType.nonMainsMedicalCooling:
      case REFERENCE_DATA_IDS.applicationType.nonMainsWater:
        const url = this.router.serializeUrl(this.router.createUrlTree(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationDetail.prefix, event.event.data.id]));
        window.open(url, '_blank');
        break;
      case REFERENCE_DATA_IDS.applicationType.victorianPatientTransportAssistanceScheme:
        const vptasUrl = this.router.serializeUrl(this.router.createUrlTree(['/', ROUTE_CONSTANTS.vptasApplication.prefix, ROUTE_CONSTANTS.vptasApplication.details.prefix, event.event.data.id]));
        window.open(vptasUrl, '_blank');
        break;
    }
  }

  actionButton_activePlacementGrid_datagrid_colLink_eppPlacementId_Clicked(event: any) {
    this.navigateToPlacementDetail(event.event.data.id);
  }

  actionButton_inactivePlacementGrid_datagrid_colLink_eppPlacementId_Clicked(event: any) {
    this.navigateToPlacementDetail(event.event.data.id);
  }

  dialogButton_createPlacement_Clicked(event: any) {
    const placementRoleId = event.createPlacementUserRole;
    if (!placementRoleId) {
      return;
    }
    this.activeDialog = ''
    switch (placementRoleId) {
      case REFERENCE_DATA_IDS.careAllowanceUserRole.careAllowanceCarer:
        if (!this.isPersonCarer) {
          this.activeDialog = POP_UP_CODES.personDetail.noCarerRole;
          break
        }
        if (!this.isPersonOracleVendor) {
          this.activeDialog = POP_UP_CODES.personDetail.noOracleVendor;
        }
        break;
      case REFERENCE_DATA_IDS.careAllowanceUserRole.careAllowanceClient:
        if (!this.isPersonClient) {
          this.activeDialog = POP_UP_CODES.personDetail.noClientRole;
        }
        break;
      default:
        return;
    }

    if (this.activeDialog) {
      this.dialogService.showDialog(this.activeDialog);
      return
    }

    this.navigate(['/', ROUTE_CONSTANTS.careAllowanceLocalAdoption.prefix, 'person', this.id, 'role', placementRoleId]);
  }

  private home(): void {
    this.navigateBackToHome();
  }

  private navigateBackToHome(ignoreUnsavedChanges = false): void {
    let routeCommands: string[] =
      this.exitRoutePrefix === ''
        ? ['/', ROUTE_CONSTANTS.person.list]
        : this.applicationId !== ''
          ? ['/', ROUTE_CONSTANTS.person.list, this.exitRoutePrefix, this.applicationId]
          : [this.exitRoutePrefix];

    const navExtras: NavigationExtras = this.getNavigationExtras();
    this.navigate(routeCommands, ignoreUnsavedChanges, navExtras);
  }

  private getNavigationExtras(): NavigationExtras {
    return {
      state: {
        placementFilterRequest: history.state.placementFilterRequest,
        personFilterRequest: history.state.personFilterRequest,
        applicationFilterRequest: history.state.applicationFilterRequest
      }
    };
  }

  private newConcessionsApplication() {
    this.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplication.forPerson, this.id]);
  }

  
  private showCreateVptasBtns(): boolean {
    //TODO: Enable this once roles are confirmed
    return true;// this.userHasVptasTeamRole;
  }
  private showNewConcessionsApplicationBtn(): boolean {
    return this.userHasConcessionsTeamRole;
  }

  private navigateToPlacementDetail(placementId: string) {
    const navExtras = this.getNavigationExtras();
    this.navigate(['/', ROUTE_CONSTANTS.person.prefixDetail, this.id, ROUTE_CONSTANTS.careAllowancePlacement.prefix, placementId], false, navExtras);

  }

  private generateOneTimeCode() {
    this.dialogService
      .showConfirm(POP_UP_CODES.personDetail.linkingCodeConfirm)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.spinnerService.showSpinner();
            const endpoint = API_ENDPOINTS.person.generateLinkingCode + '/' + this.id;
            this.appDataService.post(endpoint, null)
              .pipe(
                take(1),
                this.errorService.errorHandler(),
                finalize(() => this.spinnerService.hideSpinner())
              )
              .subscribe(data => {
                if (data?.status === SAVE_RESULT_STATUS.success) {
                  this.dialogService.showDialog(POP_UP_CODES.personDetail.linkingCodeSuccessful, null, { oneTimeCode: data.linkingCode });
                } else {
                  this.dialogService.showDialog(POP_UP_CODES.personDetail.linkingCodeError);
                }
              })
            break;
          }
        }
      });
  }

  createPlacement() {
    this.activeDialog = POP_UP_CODES.personDetail.createPlacement;
    this.dialogService.showDialog(this.activeDialog);
  }

  dialogButton_Clicked(event: any): void {
    this.reloadPage(true);
  }

  private showGenerateOneTimeCodeBtn(): boolean {
    return this.showGenerateLinkingCode === true;
  }

  private bankDetails() {
    this.router.navigate(['/', ROUTE_CONSTANTS.bankDetails.prefix, this.id],);
  }

  private createNominatedPatient() {

    const routeParts = ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeNominatedPatientDetails.edit.replace(':id', this.id).split('/').filter(part => part);
    this.router.navigate(['/', ...routeParts]);
  }

  private createVptasApplication() {
    this.activeDialog = POP_UP_CODES.personDetail.createVptasSource;
    this.dialogService.showDialog(this.activeDialog);
  }

  dialogButton_createVptasSource_Clicked(event: any) {
    const routeParts = ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeApplication.newForPerson
      .replace(':personId', this.id)
      .split('/')
      .filter(part => part);

    // Add query parameters for VPTAS application source
    const queryParams = {
      vptasApplicationSource: event.vptasApplicationSource,//'addnewpostaladdress',
      vptasApplicationSourceDate: event.vptasApplicationSourceDate//  '01/11/2025'
    };

    this.router.navigate(['/', ...routeParts], { queryParams });
  }

  private editContactDetails() {
    const navExtras: NavigationExtras = this.getNavigationExtras();
    if (this.isCrisOrCrisspRecordPresent) {
      this.dialogService
        .showConfirm(POP_UP_CODES.personDetail.checkCrisRecordPresent)
        .pipe(take(1))
        .subscribe(data => {
          switch (data as DialogResult) {
            case DialogResult.ACCEPTED: {
              this.router.navigate(['/', ROUTE_CONSTANTS.person.careAllowancePerson.prefix, this.id], navExtras);
              break;
            }
          }
        });
    }
    else {
      this.router.navigate(['/', ROUTE_CONSTANTS.person.careAllowancePerson.prefix, this.id], navExtras);
    }
  }
}
